import App from '../../App'

function IndexPage() {
  return <App />
}

export default IndexPage
